export const onboarding_content_card_style = {
  CardcontentSx: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 8px 69px #0000001A',
    borderRadius: '12px',
    px: 4,
    py: 5,
    mt: 2.5,
    width: '435px',
  },

  createPasswordSx: {
    fontSize: '20px',
    color: 'text.primary',
    textAlign: 'left',
    fontWeight: 600,
    py: 1.5,
  },
  hcLogoSx: {
    ml: -1.15,
  },
  inputGroupSx: {
    pt: 1,
  },
  buttonStyleSx: {
    textTransform: 'capitalize',
  },
};
